import { GRID_CONFIG } from "../../types/Config";
import { Question, QuestionTypeInt } from "../../types/Interface";
import genRandomlyRotation from "./helpers/genRandomlyRotation";
import genRandomlyShapeType from "./helpers/genRandomlyShapeType";
import genPivotPoint from "./helpers/genPivotpoint";
import genRandomStartPoint from "./helpers/genRandomStartPoint";
import genShapeCoords from "./helpers/genShapeCoords";
import getOffsets from "./helpers/getOffsets";
import genRotatedShape from "./helpers/genRotatedShape";
import genQuestionType from "./helpers/getQuestionType";
import getDescription from "./helpers/getDescription";


export default function generateRandomlyQuestion(prevQuestion: Question = {} as Question, QuestionTypes: QuestionTypeInt): Question {
	const shapeType = genRandomlyShapeType(prevQuestion?.shapeType);
	const offsets = getOffsets(shapeType);
	const pivotPoint = genPivotPoint(GRID_CONFIG);
	const startPoint = genRandomStartPoint(GRID_CONFIG, offsets);
	const rotation = genRandomlyRotation(GRID_CONFIG, startPoint, pivotPoint, offsets);
	if (!rotation) {
		return generateRandomlyQuestion(prevQuestion, QuestionTypes);
	}

	const { shapePoints, centerPoint } = genShapeCoords(shapeType, startPoint);
	const rotatedShapePoints = genRotatedShape(pivotPoint, shapePoints, rotation);
	const qType = genQuestionType(QuestionTypes);
	const desc = getDescription(qType, rotation);
	const origin = { x: 0, y: GRID_CONFIG.height / GRID_CONFIG.cellSize };

	return {
		qType,
		desc,
		shapeType,
		shapePoints,
		rotatedShapePoints,
		centerPoint,
		pivotPoint,
		origin,
		rotation,
	}
}


